import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Toast } from "ngx-toastr";

@Component({
  selector: "app-enterprise-toast",
  standalone: true,
  template: `
    @let toastOptions = options();
    @let toastMessage = message();

    @if (toastOptions.closeButton) {
      <button (click)="remove()" type="button" class="toast-close-button" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    }

    @if (resolvedTitle) {
      <div [class]="toastOptions.titleClass" [attr.aria-label]="resolvedTitle">
        {{ resolvedTitle }}

        @if (duplicatesCount) {
          <ng-container>[{{ duplicatesCount + 1 }}]</ng-container>
        }
      </div>
    }

    @if (toastMessage) {
      @if (toastOptions.enableHtml) {
        <div role="alert" [class]="toastOptions.messageClass" [innerHTML]="toastMessage"></div>
      } @else {
        <div role="alert" [class]="toastOptions.messageClass" [attr.aria-label]="toastMessage">
          {{ toastMessage }}
        </div>
      }
    }

    @if (toastOptions.progressBar) {
      <div>
        <div class="toast-progress" [style.width]="width() + '%'"></div>
      </div>
    }
  `,
  host: {
    "(click)": "tapToast()",
    "(mouseenter)": "stickAround()",
    "(mouseleave)": "delayedHideToast()",
    "[class]": "toastClasses()",
    "[style.display]": "displayStyle()",
    "[style.--animation-easing]": "params.easing",
    "[style.--animation-duration]": "params.easeTime + 'ms'",
    "animate.enter": "toast-in",
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnterpriseToastComponent extends Toast {
  get resolvedTitle(): string {
    const title = this.title().trim();

    if (!title) {
      return this.defaultTitleForType();
    }

    const normalizedTitle = title.toLowerCase();

    if (normalizedTitle === "error") {
      return "Error";
    }

    if (normalizedTitle === "info") {
      return "Info";
    }

    if (normalizedTitle === "warn") {
      return "Warning";
    }

    return title;
  }

  private defaultTitleForType(): string {
    switch (this.toastPackage.toastType) {
      case "toast-success":
        return "Success";
      case "toast-error":
        return "Error";
      case "toast-warning":
        return "Warning";
      case "toast-info":
        return "Info";
      default:
        return "Update";
    }
  }
}
